import logoWhite from '../../../shared/assets/logo/liftpeak_white.png';
import './Header.css';

export function Header() {
  return (
    <header className="header">
      <div className="logo-container">
        <img src={logoWhite} className="logo" alt="Liftpeak logo" />
      </div>
      <a
        href="https://app.liftpeak.com"
        className="header-app-link"
        rel="noopener noreferrer"
      >
        Open on Web
        <svg className="header-app-link-arrow" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path d="M2.5 10.5L10.5 2.5M10.5 2.5H4.5M10.5 2.5V8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </a>
    </header>
  );
}

export default Header;


